@if (requiredData()) {
  <claas-app-header>
    <span ngProjectAs="block-start">
      <span class="font-secondary-color"
        >{{ "features.product-overview.prefix-headline" | translate }} |
      </span>
      <span>{{ "features.product-overview.headline" | translate }}</span>
    </span>
    <div class="app-header-block-end" ngProjectAs="block-end">
      <claas-toggle
        id="toggle-international-catalog"
        [disabled]="false"
        [label]="
          'features.product-overview.internationalCatalogLabel' | translate
        "
        [checked]="isInternationalCatalog()"
        [required]="false"
        [disableRipple]="true"
        [inputTop]="false"
        [size]="toggleSize.DEFAULT_MEDIUM"
        [truncatedText]="true"
        (changed)="handleToggleInternationalCatalog($event)"
      ></claas-toggle>
      <claas-product-family-year-select
        [options]="years()"
        [defaultOption]="defaultYear()"
      ></claas-product-family-year-select>
      <claas-document-settings-modal-button></claas-document-settings-modal-button>
    </div>
  </claas-app-header>
  <section class="app-section">
    <claas-product-family-aside></claas-product-family-aside>
    <div class="results-wrapper">
      @if (onlyFavoritesStatus() && favoriteIds()?.length === 0) {
        <claas-empty-favorites-list>
          <div class="empty-favorites-info">
            <h1 class="empty-favorites-title font-3xl">
              {{
                "features.emptyFavoritesList.emptyFavoritesTitle" | translate
              }}
            </h1>
            <p class="empty-favorites-text font-m">
              {{
                "features.emptyFavoritesList.emptyFavoritesProducts.emptyFavoritesText"
                  | translate
              }}
            </p>
            <p class="empty-favorites-text font-m">
              {{
                "features.emptyFavoritesList.emptyFavoritesProducts.emptyFavoritesTextCta"
                  | translate
              }}
            </p>
          </div>
          <div class="favorites-toggle-wrapper">
            <claas-toggle
              id="toggle-button"
              [disabled]="false"
              [label]="'pia.shared.toggleFavouritesButtonLabel' | translate"
              [checked]="isChecked()"
              [required]="false"
              [disableRipple]="true"
              [inputTop]="false"
              [size]="toggleSize.DEFAULT_MEDIUM"
              [truncatedText]="true"
              (changed)="handleToggleFavouritesChange($event)"
            ></claas-toggle>
          </div>
        </claas-empty-favorites-list>
      }
      @for (family of productFamiliesFiltered(); track family.ID) {
        @if (productSeries()?.[`${family.ID}`]?.length) {
          <h4 [id]="family.ID" class="products-list-title font-2xl">
            {{ family.Name }}
          </h4>
          <claas-product-family-products-list
            [productsList]="productSeries()?.[`${family.ID}`] ?? []"
          ></claas-product-family-products-list>
        }
      }
    </div>
  </section>
} @else {
  <!--
    Escape hatch: without the product header there would be no way back out of
    an international catalogue that carries no data for the current year or
    language — "Back to dashboard" would resolve to the same empty state.
  -->
  @if (isInternationalCatalog()) {
    <div class="international-catalog-fallback">
      <claas-toggle
        id="toggle-international-catalog-fallback"
        [disabled]="false"
        [label]="
          'features.product-overview.internationalCatalogLabel' | translate
        "
        [checked]="true"
        [required]="false"
        [disableRipple]="true"
        [inputTop]="false"
        [size]="toggleSize.DEFAULT_MEDIUM"
        [truncatedText]="true"
        (changed)="handleToggleInternationalCatalog($event)"
      ></claas-toggle>
    </div>
  }
  <claas-not-found></claas-not-found>
}
